import { Calendar } from "lucide-react";

import { formatISODate } from "@/lib/date-formatter";

interface VisitConfirmedDateProps {
  visitDate: string;
}

export const VisitConfirmedDate = ({ visitDate }: VisitConfirmedDateProps) => {
  return (
    <div
      className="mt-1 flex items-center gap-x-1.5 text-sm text-gray-600"
      data-test-id="visit-confirmed-date"
    >
      <Calendar className="size-4" />
      <span>{formatISODate(visitDate, { format: "date" })}</span>
    </div>
  );
};
